import factoryReproductionDefaults from '../factoryreproductions/config.js';

const autoSyncKey = 'awtoffroad';

window.Convermax.verifyFitmentPositionAsync = function verifyFitmentPositionAsync(variantId) {
  // 'facet.0.field=Year&facet.0.selection=2014&facet.1.field=Make&facet.1.selection=Ford&facet.2.field=Model&facet.2.selection=F-150'
  const requestFacets = window.Convermax.getVehicleRequestParams();

  if (!requestFacets) {
    return Promise.reject(new Error('Please, select a vehicle first.'));
  }

  const url = `https://factoryreproductions.myconvermax.com/search.json?filterquery=product_id%3A${variantId}&pagesize=1&mode=VerifyFitment&${requestFacets}&variantsMode=Strip`;
  return window
    .fetch(url, { method: 'GET' })
    .then((response) => {
      if (response?.ok) {
        return response.text();
      }

      throw new Error('Something went wrong. If this error persists, please notify Convermax.');
    })
    .then((responseText) => {
      const response = JSON.parse(responseText);

      const [item] = response.Items;

      if (!item) {
        throw new Error(
          `No fitments found with id: '${variantId}'. Please check if variant id is correct or start reindexing.`,
        );
      }

      try {
        handleAutoSyncBannerOnVerify(response);
      } catch (error) {
        console.error(error);
      }

      return { fits: item.fitsTheVehicle, positionCompatibility: item.position_compatibility };
    });
};

function handleAutoSyncBannerOnVerify(response) {
  if (!factoryReproductionDefaults.isProductPage) {
    return;
  }

  const autoSyncBanner = window.document.querySelector('#cm_on-your-ride');
  const autoSyncButton = window.document.querySelector(
    '.cm_vehicle-widget__verify-fitment .cm_view-on-vehicle-btn',
  );

  const item = response.Items?.[0];
  const fits = item?.fitsTheVehicle;
  const autoSyncId = item?.autosync_id;
  const autoSyncPartNumber = autoSyncId || item?.autosync_mpn;
  const isTire = item?.FitmentType?.includes('Tire');
  const isAutoSyncAllowed = item?.is_autosync_allowed;
  // the vehicle is not stored in the state yet, so we can't use window.Convermax.getVehicle() at the moment
  const autoSyncVehicleId = response?.Extra?.AutoSyncVehicleId;

  if (fits === 'yes' && isAutoSyncAllowed && autoSyncVehicleId && autoSyncPartNumber) {
    autoSyncBanner?.classList.remove('cm_hide');
    autoSyncButton?.classList.remove('cm_hide');
    updateVisualizationPDP(autoSyncVehicleId, autoSyncPartNumber, isTire, Boolean(autoSyncId));
  } else {
    autoSyncBanner?.classList.add('cm_hide');
    autoSyncButton?.classList.add('cm_hide');
    window.document.querySelector('#cm_on-your-ride-inner')?.remove();
  }
}

function updateVisualizationPDP(autoSyncVehicleId, autoSyncPartNumber, isTire, useAutoSyncId) {
  const autoSyncBanner = window.document.querySelector('#cm_on-your-ride');
  if (!autoSyncBanner) {
    return;
  }

  if (!autoSyncVehicleId || !autoSyncPartNumber) {
    return;
  }

  window.document.querySelector('#cm_on-your-ride-inner')?.remove();

  const innerDiv = window.document.createElement('div');
  innerDiv.id = 'cm_on-your-ride-inner';
  autoSyncBanner.appendChild(innerDiv);

  setTimeout(() => {
    try {
      window.Convermax.autoSyncVisualizeVehicle({
        autoSyncConfig: {
          elId: 'cm_on-your-ride-inner',
          height: '400px',
          vehicleImageSize: 640,
          widthAdjustment: 'scale',
        },
        vehicleId: autoSyncVehicleId,
        autoSyncPartNumber,
        partLoader: window.Convermax.createAutoSyncPartLoader(isTire, useAutoSyncId),
      });
    } catch (error) {
      if (error.name !== 'NotSupportedError') {
        console.error('Failed to visualize vehicle', error);
      }
    }
  }, 0);
}

export default {
  includes: ['factoryreproductions'],
  ...factoryReproductionDefaults,
  fitmentSearch: {
    ...factoryReproductionDefaults.fitmentSearch,
    onVerifyFitmentInitResponseReceived: handleAutoSyncBannerOnVerify,
    onVerifyFitmentResponseReceived: handleAutoSyncBannerOnVerify,
    autoSyncKey,
  },
};
